<template>
  <section class="mt-4 mb-4">
    <section-title id="agency">Vitalliance {{ agence.name }}</section-title>
    <div class="row">
      <div class="col-lg-12">
        <!-- <b-card class="mb-3 shadow" img-src="../../../assets/map.jpg"> -->
        <b-card class="mb-3 shadow" v-if="agence.city">
          <!-- Google Maps Déveloper Code  -->
          <GmapMap
            ref="mapAgence"
            :center="center"
            :zoom="15"
            map-type-id="terrain"
            style="width: 100%; height: 400px"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center = m.position"
            />
          </GmapMap>

          <b-media class="mt-3 align-items-center">
            <svgicon
              slot="aside"
              icon="pin"
              width="48"
              height="48"
              color="var(--primary)"
            ></svgicon>
            <p class="mb-0">
              {{ agence.address }}, {{ agence.city }}, {{ agence.zipcode }}
              <!-- Allée de la Mandallaz, PAE la Bouvarde, Duocité B  -->
              <!-- 74370 Metz-tessy -->
            </p>
          </b-media>
          <hr />
          <p>
            <svgicon icon="clock" color="var(--primary)" class="mr-1"></svgicon>
            <small class="text-muted text-uppercase">{{
              $t("team-page-agency-opening-hours")
            }}</small>
          </p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" width="33%" class="small text-uppercase">
                    {{ $t("team-page-agency-day") }}
                  </th>
                  <th scope="col" width="33%" class="small text-uppercase">
                    {{ $t("team-page-agency-hours") }}
                  </th>
                  <th scope="col" width="33%" class="small text-uppercase">
                    {{ $t("team-page-agency-telephone-permanence") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(day, i) in workDays" :key="i + 'work-days'">
                  <th scope="row">{{ day }}</th>
                  <td>
                    {{
                      horairesAgence[day].start != null
                        ? moment(horairesAgence[day].start, "HH:mm").format(
                            "HH[h]mm"
                          ) +
                          " - " +
                          moment(horairesAgence[day].end, "HH:mm").format(
                            "HH[h]mm"
                          )
                        : "Fermé"
                    }}
                  </td>
                  <td>6h – {{ $t("team-page-agency-midnight") }}</td>
                </tr>

                <tr v-for="(day, i) in weekendDays" :key="i + 'weekend-days'">
                  <th scope="row">{{ day }}</th>
                  <td>
                    {{
                      horairesAgence[day].start != null
                        ? moment(horairesAgence[day].start, "HH:mm").format(
                            "HH[h]mm"
                          ) +
                          " - " +
                          moment(horairesAgence[day].end, "HH:mm").format(
                            "HH[h]mm"
                          )
                        : "Fermé"
                    }}
                  </td>
                  <td>6h – {{ $t("team-page-agency-midnight") }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div slot="footer">
            <b-button :href="'tel:' + agence.tel" variant="primary">
              <svgicon
                icon="phone"
                class="mr-1"
                width="17"
                height="17"
              ></svgicon>
              {{ agence.tel | formatPhone }} </b-button
            >&nbsp;
            <!-- <small>Lun – Dim, 6h à minuit. Appel non surtaxé.</small> -->
          </div>
        </b-card>

        <b-card class="mb-3" v-if="isLoading && !Object.keys(agence).length">
          <b-media class="text-center">
            <spinner height="128" width="128"></spinner>
          </b-media>
        </b-card>

        <b-card
          class="mb-3"
          v-if="!agence.city && !isLoading && !errorCoordonneesAgence"
        >
          <b-media>{{ $t("team-page-agency-no-data") }}</b-media>
        </b-card>

        <b-card class="mb-3" v-if="errorCoordonneesAgence">
          <b-media v-html="$t('team-page-agency-data-error')"> </b-media>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import fallbackToAvatar from "../../Mixins/fallbackToAvatar.js";
import vitacenterImgSrc from "../../Mixins/VitacenterImgSrc.js";
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import { mapActions, mapGetters } from "vuex";

var moment = require("moment");

export default {
  components: {
    SectionTitle,
    Spinner
  },
  mixins: [fallbackToAvatar, vitacenterImgSrc],
  data() {
    return {
      moment: moment,
      agence: {},
      horairesAgence: {},
      workDays: ["lundi", "mardi", "mercredi", "jeudi", "vendredi"],
      weekendDays: ["samedi", "dimanche"],
      markers: [],
      center: {
        lat: 0,
        lng: 0
      },
      cda: {},
      errorCoordonneesAgence: false,
      errorHorairesAgences: false
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapGetters("agency", ["agencyData", "agencyError"]),
    ...mapGetters(["isLoading"])
  },
  watch: {
    agencyData(newData) {
      this.putDataIntoMap(newData);
    },
    agencyError() {
      this.errorCoordonneesAgence = true;
      this.errorHorairesAgences = true;
    }
  },
  methods: {
    ...mapActions("auth", ["handleAxiosErrors"]),
    ...mapActions("agency", ["loadAgences"]),
    load() {
      if (this.agencyData) {
        this.putDataIntoMap(this.agencyData);
      } else {
        this.loadAgences();
      }
    },

    putDataIntoMap(data) {
      // Agence
      this.agence = data;
      const position = {
        lat: this.agence.lat,
        lng: this.agence.lgn
      };
      this.markers.push({ position: position });
      this.center = position;
      // Horaires Agence
      this.horairesAgence = data.horairesAgence;
    }
  }
};
</script>
